var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bjy-sidebar",class:{ 'bjy-active': _vm.show }},[_c('div',{staticClass:"bjy-toggle-btn",on:{"click":function($event){_vm.show = !_vm.show}}},[_vm._v("文档列表")]),_c('div',{staticClass:"bjy-doc-list"})])
}
var staticRenderFns = []

export { render, staticRenderFns }